export default __webpack_public_path__ + "images/logoRefinery29.82ba80a76e6509c210630f5e4e8744d7.svg"